import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';

type Region = 'ca' | 'ca-on';

/**
 * Get Terms & Conditions URL based on user's region
 */
const getTermsUrl = (region: Region): string => {
  const urls: Record<Region, string> = {
    ca: 'https://bet99.com/en/promotions/bet99-f2p-pickem-games',
    'ca-on': 'https://on.bet99.ca/en/promotions/bet99-f2p-pickem-games',
  };
  return urls[region] || urls.ca; // Default to 'ca' if region is unknown
};

const AppFooter: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Get region from user context, default to 'ca'
  const region: Region = (user?.location as Region) || 'ca';
  const termsUrl = getTermsUrl(region);

  return (
    <footer className="px-4 py-3 bg-app-surface border-t border-border/30 text-center">
      <a
        href={termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-text-secondary hover:text-bet99-primary transition-colors"
      >
        <span className="font-bold">{t('footer.termsAndConditions')}</span>
      </a>
    </footer>
  );
};

export default AppFooter;
